const UserSchema = {
  id: 'UserSchema',
  type: 'object',
  required: [
    'username',
    'password',
    'firstName',
    'lastName',
    'role',
    'provider'
  ],
  properties: {
    username: {
      type: 'string',
      minLength: 4,
      maxLength: 20
    },
    password: {
      type: 'string',
      minLength: 4,
      maxLength: 20
    },
    firstName: {
      type: 'string',
      minLength: 3
    },
    lastName: {
      type: 'string',
      minLength: 3
    },
    provider: {
      type: 'string',
      minLength: 3
    },
    role: {
      type: 'string',
      enum: ['superadmin', 'superprovider', 'admin', 'user']
    }
  }
};

export default UserSchema;
